import { SHELL } from '../lib/branding.ts';
import { KakaoIcon, PhoneIcon } from './icons.tsx';

/**
 * 문의 안내 — 로그인·가입·메일 인증·승인 대기 화면에 붙인다.
 * 가입 단계에서 막힌 사람은 로그인할 수 없으므로 화면 안에 연락처가 있어야 한다.
 * 화이트라벨이면 대행사 연락처이고, 값이 없는 칸은 숨긴다(261025-agency-white-label).
 */
export function SupportContact({ className }: { className?: string }) {
  const { support } = SHELL;
  if (!support.tel && !support.kakaoUrl && !SHELL.homepage) return null;
  return (
    <div className={`space-y-3 ${className ?? ''}`}>
      <p className="font-semibold text-slate-700 text-sm">도움이 필요하시면 연락 주세요</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {support.tel && (
          <a
            href={`tel:${support.tel.replace(/\D/g, '')}`}
            className="flex items-center gap-3 rounded-xl bg-white p-3 ring-1 ring-slate-200 transition hover:-translate-y-px hover:ring-slate-300"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
              <PhoneIcon className="h-4 w-4" />
            </span>
            <span className="leading-tight">
              <span className="block text-slate-500 text-xs">대표번호</span>
              <span className="block font-bold text-slate-900">{support.tel}</span>
            </span>
          </a>
        )}
        {support.kakaoUrl && (
          <a
            href={support.kakaoUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 rounded-xl bg-kakao p-3 shadow-[0_6px_16px_#fee50047] transition hover:-translate-y-px hover:brightness-95"
          >
            <KakaoIcon className="h-9 w-9 shrink-0" />
            <span className="leading-tight text-[#191919]">
              <span className="block text-xs opacity-70">바로 물어보기</span>
              <span className="block font-bold">카카오톡으로 상담하기</span>
            </span>
          </a>
        )}
      </div>
      {SHELL.homepage && (
        <p className="text-slate-500 text-xs">
          {SHELL.serviceName} 소개{' '}
          <a className="font-semibold hover:underline" href={SHELL.homepage} target="_blank" rel="noreferrer">
            {SHELL.homepage.startsWith('http') ? new URL(SHELL.homepage).host : window.location.host}
          </a>
        </p>
      )}
    </div>
  );
}
